export default "/_next/static/chunks/fonts/Montserrat-Bold-latin-97f43d6891e22c37b6596239b7e86d37.woff2";